import React from 'react'

import {Navigate} from 'react-router'
import {useLocation} from 'react-router-dom'

import {Permission} from '../../types'

import ROUTES from '../../routes'

type Props = {
  isAuthenticated: boolean
  isPermitted: boolean
  children: React.ReactNode
}
export const RequireAuth = ({isAuthenticated, isPermitted, children}: Props) => {
  const location = useLocation()

  if (isAuthenticated && isPermitted) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>
  }

  if (isAuthenticated && !isPermitted) {
    return <Navigate to={ROUTES.FORBIDDEN} />
  }

  return <Navigate to={ROUTES.SIGN_IN} state={{from: location.pathname}} />
}

export const isPermitted = (
  permission: Permission,
  requiredPermissions: Permission[] | undefined
) =>
  !requiredPermissions ||
  requiredPermissions.length === 0 ||
  requiredPermissions.includes(permission)
